import { AppCrashedIllustrationIcon } from '@weblite/icons'
import { t } from '$i18n'
import { fullReload } from '$helper/functions/fullReload'
import { SecondaryButton } from '$common/buttons/secondary-button'
import { ErrorPage } from '../error-page'

const AppCrashed = () => {
  return (
    <ErrorPage
      isOpen
      icon={
        <AppCrashedIllustrationIcon sx={{ width: '140px', height: '140px' }} />
      }
      title={t('errorBoundary.applicationCrashed')}
      description={t('errorBoundary.tryAgainOrCallSupport')}
      actionButtons={
        <SecondaryButton
          text={t('myAccountEdit.return')}
          onClick={fullReload}
          fullWidth
        />
      }
      hideBackdrop
    />
  )
}

export default AppCrashed
